/* ══════════════════════════════════════════════════════════════
   Risk Metrics Cards — Sharpe, Sortino, Max DD, Win Rate
   ══════════════════════════════════════════════════════════════ */

export interface RiskMetricsData {
    totalReturn: number;
    cagr: number;
    sharpeRatio: number;
    sortinoRatio: number;
    maxDrawdown: number;
    winRate: number;
    profitFactor: number;
    calmarRatio: number;
    totalTrades: number;
    avgHoldingPeriod: number;
    expectancy: number;
    bestTrade: number;
    worstTrade: number;
}

function metricCard(label: string, value: string, subtitle: string, color?: string): string {
    return `
    <div class="risk-metric-card">
      <span class="rm-label">${label}</span>
      <span class="rm-value" ${color ? `style="color:${color}"` : ''}>${value}</span>
      <span class="rm-sub">${subtitle}</span>
    </div>`;
}

export function renderRiskMetricsCards(container: HTMLElement, data?: RiskMetricsData): void {
    const d: RiskMetricsData = data || {
        totalReturn: 18.5, cagr: 18.5, sharpeRatio: 1.42, sortinoRatio: 2.15,
        maxDrawdown: 5.8, winRate: 62.5, profitFactor: 2.1, calmarRatio: 3.19,
        totalTrades: 48, avgHoldingPeriod: 4.2, expectancy: 1250, bestTrade: 5200, worstTrade: -2800,
    };

    const sharpeColor = d.sharpeRatio >= 1.5 ? 'var(--india-green)' : d.sharpeRatio >= 1 ? 'var(--india-saffron)' : 'var(--india-red)';
    const wrColor = d.winRate >= 55 ? 'var(--india-green)' : d.winRate >= 45 ? 'var(--india-saffron)' : 'var(--india-red)';

    container.innerHTML = `
    <div class="risk-metrics-panel glass-card">
      <div class="card-header"><h3>📊 Risk Metrics</h3></div>
      <div class="risk-metrics-grid">
        ${metricCard('Total Return', `${d.totalReturn >= 0 ? '+' : ''}${d.totalReturn}%`, '1 Year', d.totalReturn >= 0 ? 'var(--india-green)' : 'var(--india-red)')}
        ${metricCard('CAGR', `${d.cagr}%`, 'Annualized')}
        ${metricCard('Sharpe', d.sharpeRatio.toFixed(2), 'Risk-Adj Return', sharpeColor)}
        ${metricCard('Sortino', d.sortinoRatio.toFixed(2), 'Downside-Adj')}
        ${metricCard('Max Drawdown', `-${d.maxDrawdown}%`, 'Peak-to-Trough', 'var(--india-red)')}
        ${metricCard('Win Rate', `${d.winRate}%`, `${d.totalTrades} trades`, wrColor)}
        ${metricCard('Profit Factor', d.profitFactor.toFixed(1), 'Wins/Losses')}
        ${metricCard('Calmar', d.calmarRatio.toFixed(2), 'Return/Drawdown')}
        ${metricCard('Expectancy', `₹${d.expectancy.toLocaleString('en-IN')}`, 'Per trade avg')}
        ${metricCard('Avg Hold', `${d.avgHoldingPeriod}d`, 'Per trade')}
        ${metricCard('Best Trade', `+₹${d.bestTrade.toLocaleString('en-IN')}`, '', 'var(--india-green)')}
        ${metricCard('Worst Trade', `₹${d.worstTrade.toLocaleString('en-IN')}`, '', 'var(--india-red)')}
      </div>
    </div>`;
}
